import {
    ADMINISTRATION,
    LIGHTING_PROFESSIONAL,
    MARKETPLACE,
    PLANNING,
    PRODUCTION_CONNECT,
    PRODUCTION_PROFESSIONAL,
    PROFILES,
    RESERVATION_PROFESSIONAL,
    SUPPLIER
} from '../common/nav/apps';
import { useContext, useMemo } from 'react';
import { UserContext } from '../common/auth/UserContext';

export default () => {
    const { application } = useContext(UserContext);

    const preFiltersByApp = useMemo(() => {
        return {
            [ADMINISTRATION.id]: [
                { identifier: 'public', value: 'false' },
                { identifier: 'inactive', value: 'false' }
            ],
            [MARKETPLACE.id]: [],
            [SUPPLIER.id]: [
                { identifier: 'public', value: 'false' },
                { identifier: 'inactive', value: 'false' }
            ],
            [PLANNING.id]: [{ identifier: 'inactive', value: 'false' }],
            [PROFILES.id]: [{ identifier: 'inactive', value: 'false' }],
            [PRODUCTION_PROFESSIONAL.id]: [{ identifier: 'inactive', value: 'false' }],
            [LIGHTING_PROFESSIONAL.id]: [{ identifier: 'inactive', value: 'false' }],
            [PRODUCTION_CONNECT.id]: [{ identifier: 'inactive', value: 'false' }],
            [RESERVATION_PROFESSIONAL.id]: [{ identifier: 'inactive', value: 'false' }]
        };
    }, []);

    return preFiltersByApp[application.id];
};
